import { render, staticRenderFns } from "./unfollow.vue?vue&type=template&id=1a6e8e72&scoped=true&"
import script from "./unfollow.vue?vue&type=script&lang=js&"
export * from "./unfollow.vue?vue&type=script&lang=js&"
import style0 from "./unfollow.vue?vue&type=style&index=0&id=1a6e8e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6e8e72",
  null
  
)

export default component.exports